import * as actions from "../../actions/auth";

export const setAuthenticateResponse = (payload: IAuthenticateResponse) => {
    return {
        type: actions.AuthenticateTypes.SET_AUTHENTICATE_RESPONSE,
        payload
    } as actions.SetAuthenticateResponse;
};
